module.exports = __webpack_public_path__ + "static/img/coins.52a1af2a.png";